var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-root",class:{ 'app-root--nav': _vm.showGlobalNav, 'app-root--fullscreen': !_vm.showGlobalNav }},[(_vm.showGlobalNav)?_c('CustomNavBar',{attrs:{"title":_vm.navTitle,"show-badge":_vm.navShowBadge,"badge-text":_vm.navBadgeText},on:{"back":_vm.onNavBack}}):_vm._e(),_c('div',{staticClass:"app-main"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }